import type { MandateResponse, MandateRevokedResponse, MandateListParams } from '../types';
import type { RequestFn } from '../client';

/** View and revoke recurring payment mandates. */
export class Mandates {
  constructor(private readonly request: RequestFn) {}

  /**
   * Retrieve a mandate by its ID.
   *
   * @param mandateId - The unique mandate ID.
   * @returns The mandate.
   */
  async retrieve(mandateId: string): Promise<MandateResponse> {
    return this.request('GET', `/mandates/${encodeURIComponent(mandateId)}`);
  }

  /**
   * Revoke an active mandate, preventing future charges.
   *
   * @param mandateId - The mandate ID to revoke.
   * @returns Revocation confirmation.
   */
  async revoke(mandateId: string): Promise<MandateRevokedResponse> {
    return this.request('POST', `/mandates/revoke/${encodeURIComponent(mandateId)}`);
  }

  /**
   * List mandates, optionally filtered by customer or status.
   *
   * @param params - Optional filter and pagination parameters.
   * @returns Array of mandates.
   */
  async list(params?: MandateListParams): Promise<MandateResponse[]> {
    return this.request('GET', '/mandates/list', {
      query: params as Record<string, string | number | undefined>,
    });
  }
}
